export default __webpack_public_path__ + "static/streifen_links-28880cf51381cf2ca6855fdb24353098.gif";